import { Dialog } from "@headlessui/react";

export default function DialogWithChildren(props) {
  const { isOpen, setIsOpen, title, children, onSave } = props;

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative">
      <div className="flex-row centered modal-backdrop">
        <Dialog.Panel className="dialog-panel w-480px p-lg">
          <Dialog.Title>{title}</Dialog.Title>
          <Dialog.Description>
            {children}
          </Dialog.Description>
          <div className="flex-row flex-gap-sm flex-justify-end">
            {onSave && <button className="card clickable pointer p-sm b-0 primary" onClick={onSave}>Save</button>}
            {setIsOpen && <button className="card clickable pointer p-sm b-0" onClick={() => setIsOpen(false)}>Cancel</button>}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}